import { AppState, Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { reconcileBackgroundAlertState } from '../../src/hooks/useLocationTracking';

export interface BackgroundAlertReconciliationArgs {
  isDriverProfile: boolean;
  isSessionActive: boolean;
  isDriving: boolean;
}

export const subscribeBackgroundAlertReconciliation = ({
  isDriverProfile,
  isSessionActive,
  isDriving,
}: BackgroundAlertReconciliationArgs): (() => void) | undefined => {
  if (Platform.OS === 'web' || !isDriverProfile) {
    return undefined;
  }

  // Keep reconciliation enabled on all native platforms. Android is the urgent ANR target, and
  // iOS benefits from the same alert-state cleanup semantics without relying on TaskManager cleanup.

  let isMounted = true;

  const reconcileAlerts = async () => {
    try {
      const notificationsEnabled = await AsyncStorage.getItem('notificationEnabled');
      if (!isMounted) {
        return;
      }

      await reconcileBackgroundAlertState({
        isSessionActive,
        isDriving,
        notificationEnabled: notificationsEnabled === 'true',
      });
    } catch (error) {
      console.error('[DashboardHome] Failed to reconcile background alerts', error);
    }
  };

  void reconcileAlerts();

  const subscription = AppState.addEventListener('change', (nextState) => {
    if (nextState === 'active') {
      void reconcileAlerts();
    }
  });

  return () => {
    isMounted = false;
    subscription.remove();
  };
};
